import type { VenueDetailsBySlugResponse } from "common/hooks/business/details/useVenueDetailsBySlug";

type WithPhotos = { reviewPhotos?: unknown[]; levelPhotos?: unknown[] };

const length = (photos: unknown) => (Array.isArray(photos) ? photos.length : 0);

/**
 * Photos the Photos tab shows, counted from the same data it reads (VenuePhotosContent):
 * area photos for Basic venues, level photos for Hybrid ones, plus experience photos.
 * `details.businessPhotos` also holds photos the tab never shows (Google Maps imagery,
 * old uploads with no area), so it can't be used for this count.
 */
export function countVenuePhotos(data: VenueDetailsBySlugResponse | undefined): number {
  if (!data) return 0;

  let areaPhotos = 0;

  // Same branch as VenuePhotosContent's enrichAndGroupPhotos.
  if (
    data.details?.templateType !== "Basic" &&
    data.details?.isPublicTemplate === "Yes" &&
    Array.isArray(data.accesibilityCategoriesHybrid)
  ) {
    data.accesibilityCategoriesHybrid.forEach((category) =>
      category.categoryOptions?.forEach((option) =>
        option.pageChildrenCategories?.forEach((page) =>
          page.accessibilityOptions?.forEach((accessibility) =>
            accessibility.levelOptions?.forEach((level) => {
              areaPhotos += length((level as WithPhotos).levelPhotos);
            }),
          ),
        ),
      ),
    );
  } else {
    data.accesibilityCategories?.forEach((category) =>
      category.tags?.forEach((tagGroup) => {
        areaPhotos += length((tagGroup as WithPhotos).reviewPhotos);
      }),
    );
  }

  const experiencePhotos = (data.details?.businessReviews ?? []).reduce(
    (sum, review) => sum + length(review.reviewPhotos),
    0,
  );

  return areaPhotos + experiencePhotos;
}
